import React from 'react';
import { clamp, isNum } from './chartUtils';
import './charts.css';

/**
 * Radial gauge for a single 0..max value. `bands` (optional [{from,to}] in value units) draws a band
 * on the track only when the caller has a real target to show; nothing is invented here.
 */
const RadialGauge = ({ value, max = 100, unit = '%', label, caption, size = 120, color = 'var(--chart-1)', bands, testId }) => {
  if (!isNum(value)) return null;
  const r = 44;
  const c = 2 * Math.PI * r;
  const frac = clamp(value / max, 0, 1);
  const text = `${value}${unit}`;
  const aria = `${label || 'Value'}: ${value}${unit}${unit === '%' ? '' : ` of ${max}`}`;
  const arc = (from, to, stroke, w, key) => (
    <circle key={key} cx="60" cy="60" r={r} fill="none" stroke={stroke} strokeWidth={w} strokeDasharray={`${(to - from) * c} ${c}`} strokeDashoffset={-from * c} transform="rotate(-90 60 60)" />
  );
  return (
    <figure className="pl-chart-gauge" style={{ margin: 0 }} data-testid={testId}>
      <svg className="pl-chart" role="img" aria-label={aria} viewBox="0 0 120 120" width={size} height={size}>
        <title>{aria}</title>
        <desc>{`Radial gauge showing ${text}.`}</desc>
        <circle cx="60" cy="60" r={r} fill="none" stroke="var(--chart-track)" strokeWidth="10" />
        {Array.isArray(bands) && bands.map((b, i) => arc(clamp(b.from / max, 0, 1), clamp(b.to / max, 0, 1), 'var(--chart-grid)', 4, `b${i}`))}
        {frac > 0 && arc(0, frac, color, 10, 'v')}
        <text x="60" y="66" textAnchor="middle" fontSize="22" fontWeight="600">{text}</text>
      </svg>
      {caption ? <figcaption className="pl-chart-caption">{caption}</figcaption> : null}
    </figure>
  );
};

export default RadialGauge;
